import React from "react";
import Link from "next/link";
import {GET_POST_UNPUBLISHED, POST_POST} from "@/authorizationActionsConstants";
import {useAuth} from "@/providers/AuthProvider";
import Input from "@/components/Input/Input";

export interface BlogMenuProps {
    searchHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function BlogMenu({searchHandler}: BlogMenuProps) {
    const {userCan} = useAuth();

    return (
        <div className="flex flex-row gap-4">
            <Input onChange={searchHandler} className="w-full mx-auto min-w-[140px]" placeholder="Search blog posts"/>
            {userCan(GET_POST_UNPUBLISHED) && <Link href="/blog/unpublished">Unpublished</Link>}
            {userCan(POST_POST) && <Link href="/blog/edit"><span className="break-keep whitespace-nowrap">Add Blog</span></Link>}
        </div>
    );
}